module.exports = __webpack_public_path__ + "static/sport/bgi-form.50aa40a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/bgi-form.png
// module id = ac7s
// module chunks = 0